import { RegisterComponent } from './components/register/register.component';
import { SwalComponentComponent } from './components/swal-component/swal-component.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ErrorComponent } from './components/error/error.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';
import { LoginComponent } from './components/login/login.component';
import { AuthGuard } from './helpers/auth.guard';
import { ForgotComponent } from './components/forgot/forgot.component';
import { HelpComponent } from './components/help/help.component';
import { AddVersionsComponent } from './components/help/add-versions/add-versions.component';
import { DocumentGuard } from './helpers/document.guard';
import { ManageAuthorizationsComponent } from './components/authorizations/manage-authorizations/manage-authorizations.component';
import { ManageLicensesComponent } from './components/licenses/manage-licenses/manage-licenses.component';
import { ReportCompaniesComponent } from './components/report-companies/report-companies.component';
import { ListNotificationsComponent } from './components/notifications/list-notifications/list-notifications.component';
import { PasswordChangedSuccessComponent } from './components/change-password/password-changed-success/password-changed-success.component';
import { InvoiceCounterComponent } from './components/invoice-counters/invoice-counter.component';
import { Rf19SummayComponent } from './components/statistics/rf19-summay.component';

export const routes: Routes = [
  {
    path: '404',
    component: ErrorComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'register',
    component: RegisterComponent
  },
  {
    path: 'forgot',
    component: ForgotComponent
  },
  {
    path: 'password-changed-success',
    component: PasswordChangedSuccessComponent
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumbs: 'Home'
    },
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },      
      {
        path: 'dashboard',
        loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'registry',
        loadChildren: () => import('./components/registry/registry.module').then(m => m.RegistryModule)
      },      
      {
        path: 'core',
        loadChildren: () => import('./components/core/core.module').then(m => m.CoreModule)
      },
      {
        path: 'document',
        loadChildren: () => import('./components/document/document.module').then(m => m.DocumentModule),
        canActivate: [DocumentGuard]
      },
      {
        path: 'billing-plus',
        loadChildren: () => import('./components/billing-plus/billing-plus.module').then(m => m.BIllingPlusModule)
      },
      {path: 'scheduler',
        loadChildren: () => import('./components/scheduler/scheduler.module').then(m => m.SchedulerModule),
        canActivate: [DocumentGuard]
      },
      {
        path: 'statistics',
        loadChildren: () => import('./components/statistics/statistics.module').then(m => m.StatisticsModule)
      },      
      {
        path: 'rf19-summary',
        loadChildren: () => import('./components/statistics/rf19-summary.module').then(m => m.Rf19SummaryModule)
      },
      {
        path: 'manage-authorizations',
        component: ManageAuthorizationsComponent,
        data: {
          breadcrumbs: 'Gestisci autorizzazioni'
        }
      },
      {
        path: 'manage-licenses',
        component: ManageLicensesComponent,
        data: {
          breadcrumbs: 'Gestisci licenze'
        }
      },
      {
        path: 'invoice-counters',
        component: InvoiceCounterComponent        
      },
      {
        path: 'profile',
        component: ProfileComponent,
        data: {
          breadcrumbs: 'Profilo'
        }
      },
      {
        path: 'help',
        component: HelpComponent,
        data: {
          breadcrumbs: 'Help',
          disableChangeCompany: true
        }
      },
      {
        path: 'add-versions',
        component: AddVersionsComponent,
        data: {
          title: 'Aggiungi Versione Software'
        }
      },
      {
        path: 'add-versions/:id',
        component: AddVersionsComponent,
        data: {
          title: 'Modifica Versione Software'
        }
      },
      {
        path: 'company-reports',
        component: ReportCompaniesComponent,
        data: {
          title: 'Lista aziende'
        }
      },
      {
        path: 'alert',
        component: SwalComponentComponent,
        data: {
          breadcrumbs: 'Alert'
        }
      },
      {
        path: 'list-notification',
        component: ListNotificationsComponent,
        data: {
          breadcrumbs: 'Elenco notifiche',
        }
      }
    ]
  },
  {
    path: '**', component: ErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,  { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
